export const generateLinkCounts = (teachers, currentUserEmail) => {
  const teacher = teachers.find(t => t.email === currentUserEmail);
  return teacher?.linkGeneratedCount || 0;
};

export const filterMaterialsByMail = (materialsJSON, currentUserEmail, students) => {
  const materials = JSON.parse(materialsJSON);
  const normalizedEmail = currentUserEmail.replace(/\./g, '');

  let filteredMaterials = materials.filter(material => material.mail === normalizedEmail);

  let additionalMaterials = [];

  // Проверяем, что students определены и являются массивом
  if (Array.isArray(students)) {
    students.forEach(student => {
      if (student.materials && typeof student.materials === 'object') {
        Object.values(student.materials).forEach(material => {
          if (material.mail === normalizedEmail && !filteredMaterials.some(m => m.id === material.id)) {
            additionalMaterials.push(material);
          }
        });
      }
    });
  }

  // Конкатенация filteredMaterials и additionalMaterials
  filteredMaterials = filteredMaterials.concat(additionalMaterials);

  return filteredMaterials;
};

export const allStatisticsStudents = students => {
  const ageRanges = {
    '3-5': 0,
    '5-7': 0,
    '7-9': 0,
    '9-13': 0,
    '12-15': 0,
    '15-18': 0,
  };

  const classObj = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
    11: 0,
    12: 0,
  };

  students.forEach(student => {
    const age = student.age;
    const classStudent = student.classStudent;

    if (age >= 3 && age < 5) ageRanges['3-5']++;
    else if (age >= 5 && age < 7) ageRanges['5-7']++;
    else if (age >= 7 && age < 9) ageRanges['7-9']++;
    else if (age >= 9 && age < 13) ageRanges['9-13']++;
    else if (age >= 12 && age < 15) ageRanges['12-15']++;
    else if (age >= 15 && age <= 18) ageRanges['15-18']++;

    if (classStudent >= 1 && classStudent <= 12) {
      classObj[classStudent]++;
    }
  });

  const result = {
    ageObj: ageRanges,
    classObj: classObj,
  };

  return result;
};

export const createMaterialsAllTime = (materialsJSON, currentUserEmail) => {
  const filteredMaterials = filterMaterialsByMail(materialsJSON, currentUserEmail);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getMonthCountObject = monthDiff => {
    const date = new Date();
    date.setMonth(date.getMonth() - monthDiff);
    return {
      count: 0,
      month: monthNames[date.getMonth()],
    };
  };

  let counts = {
    currentMonth: getMonthCountObject(0),
    oneMonthAgo: getMonthCountObject(1),
    twoMonthsAgo: getMonthCountObject(2),
    threeMonthsAgo: getMonthCountObject(3),
    fourMonthsAgo: getMonthCountObject(4),
    fiveMonthsAgo: getMonthCountObject(5),
  };

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  filteredMaterials.forEach(material => {
    if (material.createTime && material.createTime.seconds) {
      const createDate = new Date(material.createTime.seconds * 1000);
      const createMonth = createDate.getMonth();
      const createYear = createDate.getFullYear();

      let monthDiff = (currentYear - createYear) * 12 + currentMonth - createMonth;

      if (monthDiff >= 0 && monthDiff < 6) {
        switch (monthDiff) {
          case 0:
            counts.currentMonth.count++;
            break;
          case 1:
            counts.oneMonthAgo.count++;
            break;
          case 2:
            counts.twoMonthsAgo.count++;
            break;
          case 3:
            counts.threeMonthsAgo.count++;
            break;
          case 4:
            counts.fourMonthsAgo.count++;
            break;
          case 5:
            counts.fiveMonthsAgo.count++;
            break;
          default:
            break;
        }
      }
    }
  });

  const result = {
    counts: counts,
    totalMaterialsCount: filteredMaterials.length,
  };

  return result;
};

export const processUserSessions = user => {
  if (!user || !user.sessionStartTime || user.sessionStartTime.length === 0) {
    return {
      totalCount: 0,
      item1: {
        value: 0,
        label: '0:00-8:00',
        color: '#A9BAF5',
      },
      item2: {
        value: 0,
        label: '8:00-16:00',
        color: '#CCD7FF',
      },
      item3: {
        value: 0,
        label: '16:00-0:00',
        color: '#E4EFFF',
      },
    };
  }

  // Функция для фильтрации уникальных сессий с интервалом в один час
  const getUniqueAndFilteredSessions = sessionDates => {
    const uniqueSessions = Array.from(new Set(sessionDates)).sort((a, b) => new Date(a) - new Date(b));
    const filteredSessions = [];
    uniqueSessions.forEach((dateStr, index) => {
      if (index === 0 || new Date(dateStr) - new Date(filteredSessions[filteredSessions.length - 1]) >= 3600000) {
        filteredSessions.push(dateStr);
      }
    });
    return filteredSessions;
  };

  const uniqueFilteredDates = getUniqueAndFilteredSessions(user.sessionStartTime);

  let count1 = 0;
  let count2 = 0;
  let count3 = 0;

  uniqueFilteredDates.forEach(dateStr => {
    const date = new Date(dateStr);
    const hours = date.getUTCHours();

    if (hours >= 0 && hours < 8) {
      count1 += 1;
    } else if (hours >= 8 && hours < 16) {
      count2 += 1;
    } else {
      count3 += 1;
    }
  });

  let totalHours1 = count1 * 1; // Например, если каждая сессия длится 1 час
  let totalHours2 = count2 * 1;
  let totalHours3 = count3 * 1;
  let totalHours = totalHours1 + totalHours2 + totalHours3;

  let percentage1 = (totalHours1 / totalHours) * 100;
  let percentage2 = (totalHours2 / totalHours) * 100;
  let percentage3 = (totalHours3 / totalHours) * 100;

  return {
    totalCount: uniqueFilteredDates.length,
    totalHours: totalHours,
    item1: {
      value: count1,
      hours: totalHours1,
      percentage: percentage1.toFixed(2),
      label: '0:00-8:00',
      color: '#A9BAF5',
    },
    item2: {
      value: count2,
      hours: totalHours2,
      percentage: percentage2.toFixed(2),
      label: '8:00-16:00',
      color: '#CCD7FF',
    },
    item3: {
      value: count3,
      hours: totalHours3,
      percentage: percentage3.toFixed(2),
      label: '16:00-0:00',
      color: '#E4EFFF',
    },
  };
};
export const processAllUserSessions = users => {
  let totalSessionsCount = 0;
  let totalHours = 0;
  let totalHours1 = 0;
  let totalHours2 = 0;
  let totalHours3 = 0;

  users.forEach(user => {
    const userSessions = processUserSessions(user);
    totalSessionsCount += userSessions.totalCount;
    totalHours1 += userSessions.item1.hours ?? 0;
    totalHours2 += userSessions.item2.hours ?? 0;
    totalHours3 += userSessions.item3.hours ?? 0;
  });

  totalHours = totalHours1 + totalHours2 + totalHours3;

  let percentage1 = totalHours !== 0 ? ((totalHours1 / totalHours) * 100).toFixed(2) : '0';
  let percentage2 = totalHours !== 0 ? ((totalHours2 / totalHours) * 100).toFixed(2) : '0';
  let percentage3 = totalHours !== 0 ? ((totalHours3 / totalHours) * 100).toFixed(2) : '0';

  return {
    totalCount: totalSessionsCount,
    totalHours: totalHours,
    item1: {
      value: totalHours1,
      percentage: percentage1,
      label: '0:00-8:00',
      color: '#A9BAF5',
    },
    item2: {
      value: totalHours2,
      percentage: percentage2,
      label: '8:00-16:00',
      color: '#CCD7FF',
    },
    item3: {
      value: totalHours3,
      percentage: percentage3,
      label: '16:00-0:00',
      color: '#E4EFFF',
    },
  };
};

export const calculateAverageSubjects = students => {
  if (!Array.isArray(students) || students.length === 0) {
    return 0;
  }

  let totalSubjects = 0;

  students.forEach(student => {
    const subjects = student.subjects || {};
    const activeSubjectsCount = Object.values(subjects).filter(subject => subject.activeSub).length;
    totalSubjects += activeSubjectsCount;
  });

  const averageSubjects = totalSubjects / students.length;
  return Math.round(averageSubjects);
};

export const calculateMonthlySessions = users => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getMonthCountObject = monthDiff => {
    const date = new Date();
    date.setMonth(date.getMonth() - monthDiff);
    return {
      count: 0,
      month: monthNames[date.getMonth()],
    };
  };

  let counts = {
    currentMonth: getMonthCountObject(0),
    oneMonthAgo: getMonthCountObject(1),
    twoMonthsAgo: getMonthCountObject(2),
    threeMonthsAgo: getMonthCountObject(3),
    fourMonthsAgo: getMonthCountObject(4),
    fiveMonthsAgo: getMonthCountObject(5),
  };

  let totalSessionsCount = 0;

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  users.forEach(user => {
    if (user.sessionStartTime) {
      const filteredSessions = user.sessionStartTime
        .map(t => new Date(t))
        .sort((a, b) => a - b)
        .filter((sessionDate, i, arr) => {
          return i === 0 || (arr[i] - arr[i - 1]) / 36e5 >= 1;
        });

      filteredSessions.forEach(sessionDate => {
        const sessionMonth = sessionDate.getMonth();
        const sessionYear = sessionDate.getFullYear();
        const hourDiff = Math.abs(now - sessionDate) / 36e5;

        if (hourDiff >= 1) {
          let monthDiff = (currentYear - sessionYear) * 12 + currentMonth - sessionMonth;

          if (monthDiff >= 0 && monthDiff < 6) {
            switch (monthDiff) {
              case 0:
                counts.currentMonth.count++;
                break;
              case 1:
                counts.oneMonthAgo.count++;
                break;
              case 2:
                counts.twoMonthsAgo.count++;
                break;
              case 3:
                counts.threeMonthsAgo.count++;
                break;
              case 4:
                counts.fourMonthsAgo.count++;
                break;
              case 5:
                counts.fiveMonthsAgo.count++;
                break;
              default:
                break;
            }
            totalSessionsCount++;
          }
        }
      });
    }
  });

  return { ...counts, totalSessionsCount };
};

export const getLineChartData = data => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonthIndex = currentDate.getMonth();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  if (!data[currentYear]) {
    return { data: {}, total: 0 };
  }

  const validMonths = months.slice(0, currentMonthIndex + 1);

  const lastSixMonths = validMonths.slice(-6);
  const lastSixMonthsData = lastSixMonths.reduce((acc, month) => {
    acc[month] = data[currentYear][month] || 0;
    return acc;
  }, {});

  const total = Object.values(lastSixMonthsData).reduce((sum, value) => sum + value, 0);

  return { data: lastSixMonthsData, total };
};
